import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { AccountsRoutes } from '../../../Router';
import { fetchApplication } from '../../../recoil';
import { BTAAccount } from './BTAAccount/BTAAccount';
import { RCFAccount } from './RCFAccount/RCFAccount';
const VALID_PRODUCT_CODES = ['BTA', 'RCF'];

export const Accounts = () => {
  let { applicationId } = useParams();
  const applicationDetails = useRecoilValue(fetchApplication(applicationId));
  const productCode = applicationDetails?.productCode;

  useEffect(() => {
    if (!VALID_PRODUCT_CODES.includes(productCode)) {
      window.location.pathname = AccountsRoutes.dashboard;
    }
  }, [productCode]);

  if (productCode === 'BTA') {
    return <BTAAccount applicationId={applicationId} />;
  }

  if (productCode === 'RCF') {
    return <RCFAccount applicationId={applicationId} businessId={applicationDetails?.businessId}/>;
  }

  return null;
};